import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";
import type { MarketComponentMarketComponentIO } from "../../generated/fresh-guard-api";

export function useMarketComponentsDeleteOptimistic() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (input: { marketComponentId: string }) => {
      const res =
        await api.marketComponentApi.apiMarketComponentsMarketComponentIdDelete(
          input.marketComponentId,
        );
      return res.data;
    },
    onMutate: async ({ marketComponentId }) => {
      await qc.cancelQueries({ queryKey: queryKeys.marketComponents.all });

      const previousList = qc.getQueryData<MarketComponentMarketComponentIO[]>(
        queryKeys.marketComponents.all,
      );

      if (previousList) {
        qc.setQueryData<MarketComponentMarketComponentIO[]>(
          queryKeys.marketComponents.all,
          (old) =>
            (old ?? []).filter((mc) => mc.id !== Number(marketComponentId)),
        );
      }

      return { previousList };
    },
    onError: (_err, _vars, context) => {
      if (context?.previousList) {
        qc.setQueryData(queryKeys.marketComponents.all, context.previousList);
      }
    },
    onSettled: (_data, _err, vars) => {
      void qc.invalidateQueries({
        queryKey: queryKeys.marketComponents.all,
      });

      if (vars.marketComponentId) {
        void qc.invalidateQueries({
          queryKey: queryKeys.marketComponents.byMarket(vars.marketComponentId),
        });
      }
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
